export function colleagueHolding(chat, viewer) {
    if (!chat || !chat.owner || !viewer) {
        return null;
    }

    return chat.owner.id === viewer.id ? null : chat.owner;
}

export function pickedUpNote(owner) {
    return `This chat was picked up by ${owner.name}`;
}
